/// <amd-module name="Feed/Legacy/Protocols/PyPi/PyPiClientTool" />
import * as React from "react";

import { IVssPageContext } from "VSS/Platform/Context";

import { FeedView } from "Feed/Common/Contracts/Feed";
import { IPackageProtocolClient } from "Feed/Legacy/Protocols/Common/IPackageProtocol";
import { IPyPiConnectToFeedPanelProps, PyPiConnectToFeedPanel } from "Feed/Legacy/Protocols/PyPi/PyPiConnectToFeedPanel";
import { HubAction } from "Feed/Legacy/Types/IHubState";
import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";

export class PyPiClientTool implements IPackageProtocolClient {
    private pageContext: IVssPageContext;
    private getPublishCommand: (feedName: string) => string;

    constructor(pageContext: IVssPageContext, getPublishCommand: (feedName: string) => string) {
        this.pageContext = pageContext;
        this.getPublishCommand = getPublishCommand;
    }

    public readonly name = "Python";

    public getConnectPanel(feed: Feed, feedViews: FeedView[], hubAction: HubAction): JSX.Element {
        return React.createElement(PyPiConnectToFeedPanel, {
            pageContext: this.pageContext,
            feed,
            getPublishCommand: this.getPublishCommand,
            feedViews,
            hubAction
        } as IPyPiConnectToFeedPanelProps);
    }
}
